import { render, staticRenderFns } from "./BnFormField.vue?vue&type=template&id=61a6a7d9&scoped=true&"
import script from "./BnFormField.vue?vue&type=script&lang=js&"
export * from "./BnFormField.vue?vue&type=script&lang=js&"
import style0 from "./BnFormField.vue?vue&type=style&index=0&id=61a6a7d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a6a7d9",
  null
  
)

export default component.exports